import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  constructor(
    private router: Router
  ) { }

  print() {
    this.router.navigate(['/',
      {
        outlets: {
          'print': ['print']
        }
      }
    ]);
  }

  onDataReady() {
    setTimeout(() => {
      window.print();
      this.router.navigate([
        {
          outlets: {
            print: null
          }
        }
      ]);
    });
  }
}
